import PropTypes from 'prop-types';
import React from 'react';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import {map} from 'lodash';

const ShoppingBreadcrumbsBar = ({ breadcrumbs }) => {

  return (
    <div className={'breadcrumbs-bar'}>
      <div className={'content'}>
        <RosettaFormattedMessage parentFilename={__filename}
          id="breadcrumbs_products_from"
          description='Breadcrumbs prefix "Products from"'
          defaultMessage="Products from"
        />
        {
          map(breadcrumbs, ({ name, path }, i) => (
            <a key={i} href={path}>{name}</a>
          )
          )
        }
      </div>
    </div>
  );
};

ShoppingBreadcrumbsBar.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      path: PropTypes.string
    }).isRequired
  )
};

export default ShoppingBreadcrumbsBar;
